// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DEbd","col":"styles_col__3YFgb"};